import { QueryClientProvider, useQuery } from "@tanstack/react-query";
import { getContentWithChildren } from "../../../../api/contentDeliveryApi";
import { OptimizelyExpandedValue } from "../../types/optimizely/expanded";
import React from "react";
import { queryClient } from "../../../../api/reactQueryClient";
import { mapContentToBlock } from "../../utils/mapContentToBlock";

interface OverridesForClasses {
    [key: string]: {
        [key: string]: string;
    };
}

const BlockRenderer = (props: { contentId: string, overridesForClasses?: OverridesForClasses }) => {
    const content = useQuery<OptimizelyExpandedValue>([`${props.contentId}`], () => getContentWithChildren(props.contentId));

    if (!content) {
        return null;
    }

    return (
        <div className="bg-neutralYellow">
            {mapContentToBlock(content.data, false, props.overridesForClasses)}
        </div>
    );
}

const BlockRendererWrapper = (props: { contentId: string, overridesForClasses?: OverridesForClasses }) => {

    return <QueryClientProvider client={queryClient}>
        <BlockRenderer contentId={props.contentId} overridesForClasses={props.overridesForClasses} />
    </QueryClientProvider>
};

export default BlockRendererWrapper;